export const RED_GRADIENT = 'linear-gradient(to right, #ed213a, #93291e)'
export const GREEN_GRADIENT = 'radial-gradient(circle at -1% 57.5%, rgb(19, 170, 82) 0%, rgb(0, 102, 43) 90%)'
export const BLACK_GRADIENT = 'linear-gradient(to right, #000000, #111111)'